import React from 'react'
import { withRouter, Link } from "react-router-dom";
import { TableOp } from '../../../components/table/TableOps.tsx';
import TableComponent from '../../../components/table/TableOps';
import ACCESS from '../../../ACCESS.js';

class UnidadesTransporte extends TableComponent {

  componentDidMount() {
    this.tableConfig(
      { dataUrl: 'unidad-transporte/filter', deleteUrl: 'unidad-transporte/delete', deleteField: 'unidad', modUrl: '/Catalogo/UnidadTransporte' },
      TableOp.Table('Unidades de Transporte', [
        { label: 'Unidad', id: 'unidad' },
        { label: 'Chofer', id: 'ut_chofer' },
        { label: 'Numero', id: 'ut_telefono' },
        // { label: 'Chofer', id: 'transportista_nombre' },
        { label: 'Transportista', id: 'transportista_nombre' },
        { label: 'Sucursal', id: 'sucursal' },
      ], [
        { id: 'edit', icon: 'edit', access: [ACCESS.CATALOGO_UNIDADES_DE_TRANSPORTE.CREAR_CATALOGO] },
        { id: 'delete', icon: 'delete', access: [ACCESS.CATALOGO_UNIDADES_DE_TRANSPORTE.ELIMINAR_CATALOGO] },
      ]))
    this.table();
  }

  render() {

    return (
      <div style={{ padding: 10 }} >
        <div style={{ width: '100%', display: 'flex', justifyContent: 'flex-end' }} >
          <Link 
            className="MuiButtonBase-root MuiButton-root MuiButton-contained MuiButton-containedPrimary"
            to="/Catalogo/UnidadTransporte">
              Crear Nueva Unidad
          </Link>
        </div>
        <this.TableRender/>
      </div>
    )
  }
}

export default withRouter(UnidadesTransporte)